module.exports = __webpack_public_path__ + "img/noclass.c132882d.png";